<template>
  <div class="login content">
    <div class="app-content">403 - Forbidden</div>
    <div class="return-button">
      <b-button @click="returnToLogin">Login</b-button>
    </div>
  </div>
</template>

<script>
export default {
  layout: "blank",
  name: "pageNotFound",
  methods: {
    returnToLogin() {
      this.$router.push(`/logout`);
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  height: 100vh;
  overflow: hidden;

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    font-size: 50px;
    text-align: center;

    footer {
      margin-top: auto;
    }
  }

  .app-content {
    background-color: $bg-light;
    margin-right: auto;
    margin-left: auto;
    width: auto;
  }
  .return-button {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 1200px) {
  .app {
    &-content {
      margin-left: 3.5rem;
    }
  }
}
</style>
